<template>
  <div class="visual-element-link">
    <FormVisualElement class="col-1/2" @valid="$emit('valid', $event)">
      <FormRow
        label="Link"
        :for-id="`visual-element-link-url-${_id}`"
        name="Link"
        class="relative"
        rules="required"
        ref="linkRow"
        @valid="isUrlValid = $event"
      >
        <v-input
          :id="`visual-element-link-url-${_id}`"
          type="text"
          name="url"
          :disabled="updateLoading || loadingScraper"
          v-model="modelUrl"
        />
        <div
          class="visua-element-valid-url flex items-center h-12 absolute right-0 top-8 transform translate-x-full"
          v-if="isUrlValid || loadingScraper"
        >
          <i
            class="icon-url w-8 inline-block p-2 align-bottom text-blue-500"
            :class="[
              {
                'loading animation-rotate animation-duration-700 animation-count-infinite': loadingScraper,
              },
            ]"
          >
            <component :is="loadingScraper ? 'icon-load' : 'icon-check'" />
          </i>
        </div>
      </FormRow>

      <template v-if="urlLoaded">
        <FormRow
          label="Titolo"
          :for-id="`visual-element-link-title-${_id}`"
          name="Titolo"
          rules="required"
        >
          <v-input
            :id="`visual-element-link-title-${_id}`"
            type="text"
            name="title"
            v-model="modelDataElement.title"
          />
        </FormRow>

        <FormRow
          label="Descrizione"
          :for-id="`visual-element-link-text-${_id}`"
          name="Descrizione"
          rules="required"
        >
          <v-medium-editor
            :id="`visual-element-link-text-${_id}`"
            name="text"
            v-model="modelDataElement.text"
          />
        </FormRow>

        <FormRow
          label="Immagine"
          :for-id="`visual-element-link-image-${_id}`"
          name="Immagine"
          rules="required"
          legend="(dimensioni minime suggerite 750x508 px)"
        >
          <v-image-input
            :id="`visual-element-link-image-${_id}`"
            :podcastId="podcastId"
            :imageWidth="750"
            :imageHeight="508"
            name="src"
            v-model="modelDataElement.src"
            :isVisualElement="true"
          />
        </FormRow>
      </template>
    </FormVisualElement>
    <div class="visual-element-link__error mt-4" v-if="error">
      <small class="legend font-bold text-error">Url non valido</small>
    </div>
  </div>
</template>

<script>
/** Packages */
import axios from 'axios'

/** Components */
import VisualElementBase from '@/components/VisualElementBase.vue'

/** Icons */
import iconLoad from '@/assets/icons/icon-load.svg'
import iconCheck from '@/assets/icons/icon-check.svg'

function isValidUrl(string) {
  let url
  try {
    url = new URL(string)
  } catch (_) {
    return false
  }
  return url.protocol === 'http:' || url.protocol === 'https:'
}

export default {
  extends: VisualElementBase,

  components: {
    iconLoad,
    iconCheck,
  },

  defaultContent: {
    url: '',
    title: '',
    text: '',
    src: '',
  },

  data() {
    return {
      updateLoading: false,
      error: false,
      isUrlValid: false,
      timerScraper: null,
      loadingScraper: false,
    }
  },

  computed: {
    urlLoaded() {
      return (
        this.isUrlValid &&
        (this.modelDataElement.title ||
          this.modelDataElement.text ||
          this.modelDataElement.src)
      )
    },
    modelUrl: {
      get() {
        return this.modelDataElement.url
      },
      set(value) {
        this.disableWatch = true
        this.modelDataElement.url = value
      },
    },
  },

  watch: {
    'modelDataElement.url'(newValue, oldValue) {
      if (this.timerScraper) clearTimeout(this.timerScraper)

      this.timerScraper = setTimeout(() => {
        if (this.isUrlValid && newValue && newValue !== oldValue) this.scraper()
        else this.reset()
      }, 700)
    },
  },

  methods: {
    async scraper() {
      const insertedUrl = this.modelDataElement.url
      const validInserted = isValidUrl(insertedUrl)
      let urlToScrape = ''
      if (validInserted) {
        urlToScrape = insertedUrl
      } else {
        const urlHttp = 'https://' + insertedUrl
        if (isValidUrl(urlHttp)) {
          this.modelDataElement.url = urlHttp
          urlToScrape = urlHttp
        } else {
          this.error = true
        }
      }
      try {
        this.updateLoading = true
        this.loadingScraper = true
        this.error = false
        const result = await axios.get('/.netlify/functions/metascraper', {
          params: {
            targetUrl: urlToScrape,
          },
        })

        const data = result.data
        this.disableWatch = false
        if (data && Object.keys(data).length) {
          this.$nextTick(() => {
            this.$set(this.modelDataElement, 'title', data.title)
            this.$set(this.modelDataElement, 'text', data.description)
            this.$set(this.modelDataElement, 'src', data.image)
            this.loadingScraper = false
            this.updateLoading = false
          })
        }
      } catch (err) {
        console.dir(err)
        this.reset()
        this.error = true
        this.loadingScraper = false
        this.updateLoading = false
      }
    },

    reset() {
      this.$set(this.modelDataElement, 'title', '')
      this.$set(this.modelDataElement, 'text', '')
      this.$set(this.modelDataElement, 'src', '')
      this.loadingScraper = false
      this.updateLoading = false
    },
  },
}
</script>
